const KEY = 'guestValidation';

export const saveGuestSession = (type, data, token, expiresAt) => {
  localStorage.setItem(KEY, JSON.stringify({ type, data, token, expiresAt }));
};

export const clearGuestSession = () => localStorage.removeItem(KEY);

export const getGuestSession = () => {
  const session = JSON.parse(localStorage.getItem(KEY) || 'null');
  if (!session?.token || !session.expiresAt || new Date(session.expiresAt) <= new Date()) {
    if (session) clearGuestSession();
    return null;
  }
  return session;
};

export const guestHeaders = () => ({ 'X-Guest-Token': getGuestSession()?.token || '' });

export const isGuestPassExpired = (error) =>
  error.response?.status === 401 && error.response?.data?.detail?.code === 'guest_pass_expired';
